<template>
  <el-drawer
    :title="`Tìm kiếm nâng cao `"
    :visible="visible"
    :show-close="!callingAPI"
    :size="'40%'"
    custom-class="filter-drawer"
    @close="$emit('close')"
  >
    <div class="p-xl filter-drawer__content">
      <el-form
        ref="form"
        :model="form"
      >
        <el-row
          label-position="top"
          type="flex"
          align="start"
          class="flex-wrap"
          :gutter="12"
        >
          <el-col
            v-for="field in fields"
            :key="field.key"
            :span="12"
          >
            <FormItem
              class="mb-s"
              :form="form"
              :field="field"
              :disabled="callingAPI"
              size="medium"
            />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="p-xl filter-drawer__footer">
      <el-button
        type="primary"
        class="w-100"
        :loading="callingAPI"
        @click="handleConfirm"
        >Tìm kiếm</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
import FormItem from "@/components/items/FormItem.vue";

import constants from "@/config/constants";
export default {
  name: "AdvancedFilterDrawer",
  components: {
    FormItem
  },
  props: {
    filterForm: Object,
    config: Object,
    visible: Boolean,
  },
  data() {
    return {
      fileType: constants.FIELD_TYPE,
      form: this.filterForm,
      callingAPI: false,
    };
  },
  computed: {
    fields() {
      return (this.config.extra.fields || [])
        .filter((f) => f.show.filter)
        .sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("search", this.form);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.filter-drawer {
  .filter-drawer__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 80px !important;
    overflow: auto;
  }
  .filter-drawer__footer {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    background: white;
  }
}
</style>
